import { ISRS } from "../apiFacades/csu/site";

export const getEpsgFromSrs = (srs: ISRS) => {
  return srs.isAssumed
    ? srs.assumedSrs.intermediateSrsEpsg
    : srs.globalSrs.epsg;
};
